module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-4.6f343891.jpg";